import type { RouteRecordRaw } from 'vue-router'

import { organizationDetailLayoutMeta } from './shared'

const routeSalesPartnerDetail: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/relations/OrganizationDetailView.vue')
  },
  name: 'sales-partner-detail',
  path: '',
}

const routeSalesPartnerFileOverview: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/file/SubmenuFiles.vue')
  },
  name: 'sales-partner-file-overview',
  path: 'file-overview',
}

const routeSalesPartnerAccounting: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/salesPartner/SubmenuAccounting.vue')
  },
  name: 'sales-partner-accounting',
  path: 'sales-partner-accounting',
}

const routeSalesPartnerSales: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/salesPartner/SubmenuSales.vue')
  },
  name: 'sales-partner-sales',
  path: 'sales-partner-sales',
}

const routeSalesPartnerRoot: RouteRecordRaw = {
  children: [
    routeSalesPartnerDetail,
    routeSalesPartnerFileOverview,
    routeSalesPartnerAccounting,
    routeSalesPartnerSales,
  ],
  component: async () => {
    return await import('@/components/relationships/organizations/OrganizationDetailBase.vue')
  },
  meta: organizationDetailLayoutMeta,
  path: 'sales-partners/:id',
}

export {
  routeSalesPartnerAccounting,
  routeSalesPartnerDetail,
  routeSalesPartnerFileOverview,
  routeSalesPartnerRoot,
  routeSalesPartnerSales,
}
